import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ScheduledInventoryTransferDetailsFragment = { __typename?: 'ScheduledInventoryTransferDocument', id: string, scheduledInventoryTransferId: string, status: Types.ScheduledInventoryTransferStatus, locationId: string, locationName: string, itemId: string, fromSku: string, fromItemName: string, grade: number, toItemId: string, toSku: string, toItemName: string, toLocationId: string, toLocationName: string, toGrade: number, effectiveDate: string, dueAt: Types.TDateISO, quantityMode: Types.ScheduledTransferQuantityMode, fixedQuantity?: number | null, scheduledByEmail: string, scheduledAt: Types.TDateISO, cancelledAt?: Types.TDateISO | null, executedAt?: Types.TDateISO | null, movedQuantity?: number | null, heldBackQuantity?: number | null, shortfallQuantity?: number | null, failureReason?: string | null };

export type ScheduledInventoryTransferStateDetailsFragment = { __typename?: 'ScheduledInventoryTransferStateData', scheduledInventoryTransferId: string, status: Types.ScheduledInventoryTransferStatus, locationId: string, itemId: string, grade: number, toItemId: string, toSku: string, effectiveDate: string, quantityMode: Types.ScheduledTransferQuantityMode, fixedQuantity?: number | null };

export type GetScheduledInventoryTransfersQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ScheduledInventoryTransferDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ScheduledInventoryTransferDocumentSortInput> | Types.ScheduledInventoryTransferDocumentSortInput>;
}>;


export type GetScheduledInventoryTransfersQuery = { __typename?: 'Query', scheduledInventoryTransfers?: { __typename?: 'ScheduledInventoryTransfersConnection', totalCount: number, nodes?: Array<{ __typename?: 'ScheduledInventoryTransferDocument', id: string, scheduledInventoryTransferId: string, status: Types.ScheduledInventoryTransferStatus, locationId: string, locationName: string, itemId: string, fromSku: string, fromItemName: string, grade: number, toItemId: string, toSku: string, toItemName: string, toLocationId: string, toLocationName: string, toGrade: number, effectiveDate: string, dueAt: Types.TDateISO, quantityMode: Types.ScheduledTransferQuantityMode, fixedQuantity?: number | null, scheduledByEmail: string, scheduledAt: Types.TDateISO, cancelledAt?: Types.TDateISO | null, executedAt?: Types.TDateISO | null, movedQuantity?: number | null, heldBackQuantity?: number | null, shortfallQuantity?: number | null, failureReason?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const ScheduledInventoryTransferDetailsFragmentDoc = new TypedDocumentString(`
    fragment ScheduledInventoryTransferDetails on ScheduledInventoryTransferDocument {
  id
  scheduledInventoryTransferId
  status
  locationId
  locationName
  itemId
  fromSku
  fromItemName
  grade
  toItemId
  toSku
  toItemName
  toLocationId
  toLocationName
  toGrade
  effectiveDate
  dueAt
  quantityMode
  fixedQuantity
  scheduledByEmail
  scheduledAt
  cancelledAt
  executedAt
  movedQuantity
  heldBackQuantity
  shortfallQuantity
  failureReason
}
    `, {"fragmentName":"ScheduledInventoryTransferDetails"});
export const ScheduledInventoryTransferStateDetailsFragmentDoc = new TypedDocumentString(`
    fragment ScheduledInventoryTransferStateDetails on ScheduledInventoryTransferStateData {
  scheduledInventoryTransferId
  status
  locationId
  itemId
  grade
  toItemId
  toSku
  effectiveDate
  quantityMode
  fixedQuantity
}
    `, {"fragmentName":"ScheduledInventoryTransferStateDetails"});
export const GetScheduledInventoryTransfersDocument = new TypedDocumentString(`
    query GetScheduledInventoryTransfers($first: Int, $after: String, $last: Int, $before: String, $where: ScheduledInventoryTransferDocumentFilterInput, $order: [ScheduledInventoryTransferDocumentSortInput!]) {
  scheduledInventoryTransfers(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...ScheduledInventoryTransferDetails
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ScheduledInventoryTransferDetails on ScheduledInventoryTransferDocument {
  id
  scheduledInventoryTransferId
  status
  locationId
  locationName
  itemId
  fromSku
  fromItemName
  grade
  toItemId
  toSku
  toItemName
  toLocationId
  toLocationName
  toGrade
  effectiveDate
  dueAt
  quantityMode
  fixedQuantity
  scheduledByEmail
  scheduledAt
  cancelledAt
  executedAt
  movedQuantity
  heldBackQuantity
  shortfallQuantity
  failureReason
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetScheduledInventoryTransfers: build.query<GetScheduledInventoryTransfersQuery, GetScheduledInventoryTransfersQueryVariables | void>({
      query: (variables) => ({ document: GetScheduledInventoryTransfersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetScheduledInventoryTransfersQuery, useLazyGetScheduledInventoryTransfersQuery } = injectedRtkApi;
